<mat-chip-set #chips class="tt-chip-cell-renderer__mat-chip-set">
    <ng-container *ngFor="let chip of chipsList">
        <mat-chip class="tt-chip-cell-renderer__mat-chip" (click)="onClick($event, chip)" [style.backgroundColor]="chip[dataColor]">
            <span [style.color]="chip[dataTextColor]">
                {{ chip[dataName] }}
            </span>
        </mat-chip>
    </ng-container>

    <mat-chip *ngFor="let id of idList" class="tt-chip-cell-renderer__mat-chip">
        {{ id }}
    </mat-chip>
</mat-chip-set>
